<template lang="html">
    <div id="page__route-list__toolbar" style="flex-grow: 3" class="report-forward-search tollbar__search">
        <div class="text">
            <span> Для печати отчёта укажите параметры фильтрации </span>
        </div>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
        <z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light  v-bind:disabled="!hasFilter"></z-icon-button>
        <div v-if="visibility" v-click-outside="hideFilter" class="md-elevation-2 dropdown">
            <div class="search-md-menu-container">
                <div class="filter-container" md-layout>
                    <div class="center-layout md-size-20 md-layout-item"> <label> Маршрутные листы </label> </div>
                    <div class="center-layout with-pr md-size-80 md-layout-item">
                        <ZInputMultyValue v-model="filter.ids" id="rl-ids" name="rl-ids" value-type="number" placeholder="№ маршрутного листа"> </ZInputMultyValue>
                    </div>
                    <div class="dropdown-button-container md-alignment-bottom-right md-size-100 md-layout-item">
                       <z-button v-on:click="doFilter" fit-content no-margin> Применить </z-button>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
    import ClickOutside from 'vue-click-outside'
    import ZInputMultyValue from '@/components/ZInputMultyValue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZButton from '@/components/ZButton.vue';
    export default {
        components: { ZInputMultyValue, ZButton, ZIconButton },
        directives: {ClickOutside},
        data() {
            return {
                visibility: false,
                filter: {
                    ids: []
                },
                filterDefault: {
                    ids: []
                },
            }
        },
        created() {
            this.init();
            if (this.$route.query && this.$route.query.custom_filter) this.filter = Object.assign({}, JSON.parse(this.$route.query.custom_filter));
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).find(item => !!item);
            }
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() { 
                this.doFilter();
            },
            /**
             * Скрыть фильтр
             */
            hideFilter() {
                this.visibility = false;
            },
            /**
             * Переключение фильтра
             */
            toggleFilter() {
                this.visibility = !this.visibility;
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                this.init();
                this.doFilter();
                return;
            },
            /**
            * Применение фильтра
            */
            doFilter() {
                this.$nextTick(() => {
                    let query = Object.assign({}, this.$route.query);
                    if (!query) query = {};
                    query.custom_filter = JSON.stringify(Object.assign({}, this.filter));
                    this.$router.push({ name: this.$route.name, params: this.$route.params, query: query});
                    this.$root.$emit('refresh-table', 'report-routelist');
                    this.hideFilter();
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// RoutelistToolbar.vue?97b65cb0